<template src="./add-section.html"> </template>
<script>
export default {
  name: "app-add-section",
  data: function() {
    return {};
  },
  methods: {
    chevronListBoxHandler() {
      this.$emit("buttonClick");
    }
  }
};
</script>

<style src="./add-section.css" scoped></style>
